export default __webpack_public_path__ + "static/media/ScreenShot_3.2b69169f.jpg";